// extracted by mini-css-extract-plugin
module.exports = {"root":"OBTColorPicker_root__3QIGk","frozen":"OBTColorPicker_frozen__eqxts","disabled":"OBTColorPicker_disabled__3xc3k"};